<script setup lang="ts">
import { useGlobalStore } from '@/stores/global';

const globalStore = useGlobalStore();
</script>

<template>
    <div>
        <v-fade-transition>
            <v-progress-circular v-show="globalStore.isLoading" color="primary" size="69" width="8" indeterminate />
        </v-fade-transition>
    </div>
</template>
